import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { IVKKontraktBetalningDTO } from "../../models/kontraktBetalningar-models";

export class UpdateKontraktBetalningarCommand extends BasicCommand<UpdateKontraktBetalningarCommand> {
    readonly kontraktGuid: string;
    readonly betalningar: IVKKontraktBetalningDTO[];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateKontraktBetalningarCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "KontraktBetalningar";

    get primaryKey(): IBetalningarPrimaryKey {
        return {
            kontraktGuid: this.kontraktGuid
        };
    }

    constructor(kontraktGuid: string, betalningar: IVKKontraktBetalningDTO[]) {
        super(UpdateKontraktBetalningarCommand.$type, UpdateKontraktBetalningarCommand.$groupKey, CommandType.Replace);
        this.kontraktGuid = kontraktGuid;
        this.betalningar = betalningar;
    }
}

export interface IBetalningarPrimaryKey extends IPrimaryKey<IBetalningarPrimaryKey>{
    kontraktGuid: string;
}
